var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "node-view-wrapper",
    { staticClass: "copilot-attr-wrapper", attrs: { as: "span" } },
    [
      _c("a-tooltip", { attrs: { title: _vm.node.attrs.label } }, [
        _c(
          "span",
          {
            staticClass: "copilot-attr-chip",
            attrs: { contenteditable: "false" },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("data_object")]),
            _vm._v(" "),
            _c("span", { domProps: { textContent: _vm._s(_vm.chipLabel) } }),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }